/* w9-collection-sidenav: mounts the rail beside the grid and groups the grid.
   Two modes, decided by the data blocks the section emits:
   - part mode (bike / ride-type pages): one section per part-* tag, ids part-<slug>
   - type mode (a part page with a "Sub-groups" block, or one named in the legacy
     type_group_collections setting): one section per rule, ids type-<slug>, plus an
     anchor sub-list under the active category in the rail. A rule is "Heading=word|word":
     a word matches the product type exactly, or appears in the title (bracketed and
     *starred* notes ignored); tag:x / type:x match a tag or the type. An exact type match
     wins, then any tag: rule, then the first heading with a matching title word - so a tag:
     rule can sit last (and render last) and still take its products, e.g. Tire Tools.
   Used & damaged stock (the handles listed in the data-w9sn-used block, i.e. products
   tagged bargain) is lifted out of every group into its own section at the bottom with
   a Bargain Bin link, so a used rotor never sits between new ones. That works in both
   modes and on a plain page with no grouping at all (plain mode).
   Nothing is re-rendered: the theme's own <li> cards are moved, so prices, badges and
   add-to-cart keep working untouched. The grid is grouped again whenever facets.js swaps
   it (a sort change), and the bike-model select is ordered through window.w9Sort. */
(function () {
  var BP = 990;

  function slug(s) {
    return String(s).toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'x';
  }

  // Legacy "handle=value|handle=value" block.
  function parseMap(text) {
    var map = {};
    String(text || '').split('|').forEach(function (pair) {
      var i = pair.lastIndexOf('=');
      if (i > 0) map[pair.slice(0, i).trim()] = pair.slice(i + 1).trim();
    });
    return map;
  }

  // Titles are matched lowercase, without "(see fitment below)" style notes.
  function norm(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/\([^)]*\)/g, ' ').replace(/\*+[^*]+\*+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function token(raw) {
    var v = String(raw).trim().toLowerCase(), kind = 'any';
    var m = /^(tag|type|title):\s*(.+)$/.exec(v);
    if (m) { kind = m[1]; v = m[2].trim(); }
    return v ? { kind: kind, v: v } : null;
  }

  // "Heading=word|word" rules, one per line (or comma-separated when there are no line
  // breaks, as the legacy setting is). A bare entry is both heading and word.
  function parseOrder(spec) {
    spec = String(spec || '');
    var groups = [];
    spec.split(spec.indexOf('\n') !== -1 ? /\r?\n/ : ',').forEach(function (e) {
      e = e.trim();
      if (!e) return;
      var label = e, list = [e];
      var i = e.indexOf('=');
      if (i > 0) { label = e.slice(0, i).trim(); list = e.slice(i + 1).split('|'); }
      var toks = list.map(token).filter(Boolean);
      if (label && toks.length) groups.push({ label: label, slug: slug(label), toks: toks });
    });
    return groups;
  }

  // Exact product-type matches win over title matches, so a type that is also a common
  // word ("Tubes") lands where it belongs even when a later rule would catch its title.
  function matchGroup(item, groups) {
    var t = norm(item.t), n = norm(item.n);
    var tags = (item.g || []).map(function (x) { return String(x).toLowerCase(); });
    var i, j, g, k;
    if (t) {
      for (i = 0; i < groups.length; i++) {
        g = groups[i];
        for (j = 0; j < g.toks.length; j++) {
          k = g.toks[j];
          if ((k.kind === 'any' || k.kind === 'type') && k.v === t) return g;
        }
      }
    }
    // Explicit tag: tokens beat title words wherever the rule sits, so a tools rule can be
    // the last group (rendered last) and still take a wrench whose title says Sprocket.
    for (i = 0; i < groups.length; i++) {
      g = groups[i];
      for (j = 0; j < g.toks.length; j++) {
        k = g.toks[j];
        if (k.kind === 'tag' && tags.indexOf(k.v) !== -1) return g;
      }
    }
    for (i = 0; i < groups.length; i++) {
      g = groups[i];
      for (j = 0; j < g.toks.length; j++) {
        k = g.toks[j];
        if (k.kind === 'tag' || k.kind === 'type') { continue; }
        else if (n && n.indexOf(k.v) !== -1) return g;
      }
    }
    return null;
  }

  // Used & damaged stock: heading, link and a handle set. Null when the page has none.
  function usedBlock() {
    var el = document.querySelector('[data-w9sn-used]');
    if (!el) return null;
    var u;
    try { u = JSON.parse(el.textContent); } catch (e) { return null; }
    if (!u || !u.label || !u.h || !u.h.length) return null;
    var set = {};
    u.h.forEach(function (h) { set[h] = true; });
    return { label: u.label, link: u.link || '', url: u.url || '', set: set };
  }

  // The data blocks are siblings of the nav, and the nav gets re-parented into
  // .facets-wrap - so look them up on the document, not inside the panel.
  function catalog(nav) {
    var used = usedBlock();
    var tmap = document.querySelector('[data-w9sn-tmap]');
    var tconf = document.querySelector('[data-w9sn-tconf]');
    if (tmap && tconf) {
      var conf, items = {};
      try { conf = JSON.parse(tconf.textContent); } catch (e) { return null; }
      var raw = tmap.textContent.trim();
      if (raw.charAt(0) === '[') {
        var arr;
        try { arr = JSON.parse(raw); } catch (e2) { return null; }
        arr.forEach(function (it) { if (it && it.h) items[it.h] = it; });
      } else {
        var lm = parseMap(raw);
        Object.keys(lm).forEach(function (h) { items[h] = { h: h, t: lm[h], n: '' }; });
      }
      return { mode: 'type', prefix: 'type-', items: items, groups: parseOrder(conf.order || ''), other: conf.other || 'More', auto: !!conf.auto, used: used };
    }
    var mapEl = document.querySelector('[data-w9sn-map]');
    var ordEl = document.querySelector('[data-w9sn-order]');
    if (!mapEl || !ordEl) {
      // No grouping on this page: only the used stock moves, the rest stays one grid.
      return used ? { mode: 'plain', prefix: 'type-', items: {}, groups: [], other: '', auto: false, used: used } : null;
    }
    var order;
    try { order = JSON.parse(ordEl.textContent); } catch (e3) { return null; }
    var pm = parseMap(mapEl.textContent), pitems = {};
    Object.keys(pm).forEach(function (h) { pitems[h] = { h: h, k: String(pm[h]).toLowerCase() }; });
    return {
      mode: 'part',
      prefix: 'part-',
      items: pitems,
      groups: order.map(function (o) { return { label: o.label, slug: o.slug, key: String(o.slug).toLowerCase(), toks: [] }; }),
      other: (nav && nav.getAttribute('data-w9sn-other')) || 'More parts',
      auto: false,
      used: used
    };
  }

  function handleOf(li) {
    var a = li.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var h = a.getAttribute('href').split('/products/')[1];
    return h ? h.split('?')[0].split('#')[0].replace(/\/$/, '') : null;
  }

  // Returns true once there is nothing more to do (grouped, or nothing to group);
  // false means the grid has not rendered yet and the caller should retry.
  function group(nav) {
    var data = catalog(nav);
    if (!data) return true;
    var ul = document.getElementById('product-grid');
    if (!ul) return false;
    if (ul.dataset.w9snGrouped) return true;
    if (!ul.children.length) return false;

    var groups = data.groups.map(function (g) { return { label: g.label, slug: g.slug, key: g.key, toks: g.toks, items: [] }; });
    var extra = {};
    var leftovers = [];
    var banners = [];
    var usedItems = [];
    // No rules and no per-type groups: the grid stays as it is, only the used stock moves.
    var plain = !groups.length && !data.auto;

    Array.prototype.slice.call(ul.children).forEach(function (li) {
      if (li.classList.contains('grid-item-block')) { banners.push(li); return; }
      var h = handleOf(li);
      if (data.used && h && data.used.set[h]) { usedItems.push(li); return; }
      var item = h ? data.items[h] : null;
      if (!item) { leftovers.push(li); return; }
      var g = null;
      if (data.mode === 'part') {
        for (var i = 0; i < groups.length; i++) { if (groups[i].key === item.k) { g = groups[i]; break; } }
      } else {
        g = matchGroup(item, groups);
        if (!g && data.auto && item.t) {
          var t = String(item.t).trim();
          (extra[t] = extra[t] || []).push(li);
          return;
        }
      }
      if (g) g.items.push(li); else leftovers.push(li);
    });

    Object.keys(extra).sort().forEach(function (t) {
      groups.push({ label: t, slug: slug(t), items: extra[t] });
    });

    var frag = document.createDocumentFragment();
    var rendered = [];

    function section(id, label, items, opts) {
      if (!items || !items.length) return;
      opts = opts || {};
      var sec = document.createElement('section');
      sec.className = 'w9sn-group' + (opts.cls ? ' ' + opts.cls : '');
      if (id) sec.id = id;
      var h2 = document.createElement('h2');
      h2.className = 'w9sn-group__title';
      h2.appendChild(document.createTextNode(label));
      var n = document.createElement('span');
      n.className = 'w9sn-group__count';
      n.textContent = items.length;
      h2.appendChild(n);
      sec.appendChild(h2);
      if (opts.link && opts.url) {
        var a = document.createElement('a');
        a.className = 'w9sn-group__link';
        a.href = opts.url;
        a.appendChild(document.createTextNode(opts.link));
        sec.appendChild(a);
      }
      var list = document.createElement('ul');
      list.className = ul.className;
      items.forEach(function (li) { list.appendChild(li); });
      sec.appendChild(list);
      frag.appendChild(sec);
      if (id) rendered.push({ id: id, label: label, count: items.length });
    }

    if (banners.length) {
      var bl = document.createElement('ul');
      bl.className = ul.className;
      banners.forEach(function (li) { bl.appendChild(li); });
      frag.appendChild(bl);
    }

    var used = usedItems.length;
    if (plain) {
      // Keep the new stock as one plain grid (no heading) and add the used section below.
      if (leftovers.length) {
        var pl = document.createElement('ul');
        pl.className = ul.className;
        leftovers.forEach(function (li) { pl.appendChild(li); });
        frag.appendChild(pl);
      }
    } else {
      groups.forEach(function (g) {
        used += g.items.length;
        section(data.prefix + g.slug, g.label, g.items);
      });
      section('', data.other, leftovers);
    }
    if (data.used) section(data.prefix + 'used', data.used.label, usedItems, { cls: 'w9sn-group--used', link: data.used.link, url: data.used.url });

    if (!used) { ul.dataset.w9snGrouped = '0'; return true; }
    ul.parentNode.insertBefore(frag, ul);
    ul.style.display = 'none';
    ul.dataset.w9snGrouped = '1';
    if (data.mode !== 'part') subnav(nav, rendered);
    spy(nav);
    return true;
  }

  // Type mode: the groups become an anchor list under the active category in the rail.
  function subnav(nav, rendered) {
    if (!nav || !rendered.length) return;
    var cur = nav.querySelector('.w9sn__list > li > a[aria-current="page"]');
    if (!cur || nav.querySelector('[data-w9sn-subnav]')) return;
    var ul = document.createElement('ul');
    ul.className = 'w9sn__sub';
    ul.setAttribute('data-w9sn-subnav', '');
    rendered.forEach(function (g) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + g.id;
      a.appendChild(document.createTextNode(g.label));
      var n = document.createElement('span');
      n.className = 'w9sn__sub-count';
      n.textContent = g.count;
      a.appendChild(n);
      li.appendChild(a);
      ul.appendChild(li);
    });
    cur.parentNode.appendChild(ul);
  }

  function spy(nav) {
    if (!nav || !window.IntersectionObserver) return;
    var links = nav.querySelectorAll('.w9sn__list a[href^="#"]');
    if (!links.length) return;
    var byId = {};
    Array.prototype.forEach.call(links, function (a) { byId[a.getAttribute('href').slice(1)] = a; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        Array.prototype.forEach.call(links, function (a) { a.removeAttribute('aria-current'); });
        var a = byId[en.target.id];
        if (a) a.setAttribute('aria-current', 'page');
      });
    }, { rootMargin: '-15% 0px -70% 0px' });
    Object.keys(byId).forEach(function (id) {
      var sec = document.getElementById(id);
      if (sec) io.observe(sec);
    });
  }

  function mount(nav, sid) {
    var wrap = document.querySelector('.facets-wrap');
    if (!wrap) return false;
    if (!wrap.contains(nav)) {
      var host = nav.parentElement;
      wrap.insertBefore(nav, wrap.firstElementChild);
      wrap.classList.add('w9sn-host');
      if (host && host.id === 'shopify-section-' + sid) host.classList.add('w9sn-moved');
    }
    return true;
  }

  function fold(nav) {
    var small = window.innerWidth < BP;
    var groups = nav.querySelectorAll('details.w9sn__group');
    for (var i = 0; i < groups.length; i++) {
      if (groups[i].dataset.w9snTouched === '1') continue;
      groups[i].open = !small;
    }
  }

  // The make's model list: engine size first, then A-Z (window.w9Sort, from w9-global-fixes).
  // "All <make>" stays on top. Menu order when the setting says so or the helper is missing.
  function orderModels(sel) {
    var S = window.w9Sort;
    var mode = sel.getAttribute('data-w9sn-model-order') || 'cc';
    if (!S || mode === 'menu') return;
    var val = sel.value;
    S.sortChildren(sel, mode === 'az' ? S.natural : S.models,
      function (o) { return o.textContent; },
      function (o) { return o.hasAttribute('data-w9sn-all') ? -1 : 0; });
    sel.value = val;
  }

  function init(nav) {
    if (!nav || nav.dataset.w9snInit === '1') return;
    nav.dataset.w9snInit = '1';
    var sid = nav.getAttribute('data-w9sn-sid');

    if (!mount(nav, sid)) {
      // The grid section may render after this one; retry briefly, then give up
      // and leave the rail where it is rather than hiding it.
      var tries = 0;
      var t = setInterval(function () { if (mount(nav, sid) || ++tries > 20) clearInterval(t); }, 100);
    }
    fold(nav);
    nav.addEventListener('click', function (e) {
      var d = e.target.closest ? e.target.closest('details.w9sn__group') : null;
      if (d) d.dataset.w9snTouched = '1';
    }, true);

    if (!group(nav)) {
      var gtries = 0;
      var gt = setInterval(function () { if (group(nav) || ++gtries > 20) clearInterval(gt); }, 100);
    }

    // facets.js replaces #ProductGridContainer's HTML on a sort change, which drops the
    // grouped sections. Group the fresh grid again. Our own insertions also fire this,
    // and group() then sees the grouped flag and does nothing.
    var container = document.getElementById('ProductGridContainer');
    if (container && window.MutationObserver) {
      var pending;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(function () { group(nav); }, 60);
      }).observe(container, { childList: true, subtree: true });
    }

    var sel = nav.querySelector('[data-w9sn-bike]');
    if (sel && sel.dataset.w9snWired !== '1') {
      sel.dataset.w9snWired = '1';
      orderModels(sel);
      sel.addEventListener('change', function () { if (this.value) window.location.href = this.value; });
    }

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { fold(nav); }, 150);
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('.w9sn[data-w9sn]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
